export default __webpack_public_path__ + "88611c6e2f9450f29ece8d2b36641670.svg";